import { Actions } from "../constants/actionTypes";

export function organizationsReducer(state = {}, action) {
  if (action.type === Actions.SET_ALL_ORGS) {
    return {
      ...state,
      allOrgs: action.data,
    };
  } else if (action.type === Actions.SET_USER_ORGS) {
    return {
      ...state,
      userOrgs: action.data,
    };
  } else if (action.type === Actions.SET_USER_ORGS_AND_SELECTED_ORG) {
    let hasRenewablePlan = state.selectedOrg?.hasRenewablePlan;
    return {
      ...state,
      userOrgs: action.data,
      selectedOrg: { hasRenewablePlan: hasRenewablePlan, ...action.orgInfo },
    };
  } else if (action.type === Actions.SELECT_ORG) {
    let hasRenewablePlan = state.selectedOrg?.hasRenewablePlan;

    return {
      ...state,
      selectedOrg: { hasRenewablePlan: hasRenewablePlan, ...action.orgInfo },
    };
  } else if (action.type === Actions.RESET_SELECTED_ORG) {
    return {
      ...state,
      selectedOrg: null,
      selectedOrgActivity: null,
    };
  } else if (action.type === Actions.LOGOUT_USER) {
    return {
      ...state,
      selectedOrg: null,
      allOrgs: null,
      userOrgs: null,
      recentlyViewedOrgs: null,
    };
  } else if (action.type === Actions.CHANGE_ORG_OWNER) {
    return {
      ...state,
      selectedOrg: {
        ...state.selectedOrg,
        ownerName: action.orgNewOwner,
      },
    };
  } else if (action.type === Actions.SET_RECENTLY_VIEWED_ORGS) {
    let recentlyViewedOrgs =
      action.data && action.data.map
        ? action.data.map((recentlyViewedOrg) => {
            let org = recentlyViewedOrg.organization;

            org.lastAccessedTs = recentlyViewedOrg.lastAccessedTS;

            return org;
          })
        : null;
    return {
      ...state,
      recentlyViewedOrgs: recentlyViewedOrgs,
    };
  } else if (action.type === Actions.SET_RECENTLY_VIEWED_SITES) {
    return {
      ...state,
      recentlyViewedSites: action.data,
    };
  } else if (action.type === Actions.SET_RECENTLY_VIEWED_ORGS_AND_SITES) {
    return {
      ...state,
      recentlyViewed: action.data,
    };
  } else if (action.type === Actions.ADD_TO_RECENTLY_VIEWED_ORGS) {
    let lastAccessedOrg = {
      organization: action.data,
      lastAccessedTS: new Date().getTime(),
    };

    let rvOrgs = state.recentlyViewedOrgs ? state.recentlyViewedOrgs : [];

    rvOrgs = rvOrgs.filter((org) => {
      return org.organization.orgId !== lastAccessedOrg.organization.orgId;
    });

    return {
      ...state,
      recentlyViewedOrgs: [lastAccessedOrg, ...rvOrgs],
    };
  } else if (action.type === Actions.ADD_TO_RECENTLY_VIEWED_SITES) {
    let lastAccessedSite = {
      siteDetails: action.data,
      lastAccessedTs: new Date().getTime(),
    };

    let rvSites = state.recentlyViewedSites ? state.recentlyViewedSites : [];

    rvSites = rvSites.filter((site) => {
      return site.siteDetails.siteId !== lastAccessedSite.siteDetails.siteId;
    });

    return {
      ...state,
      recentlyViewedSites: [lastAccessedSite, ...rvSites],
    };
  } else if (action.type === Actions.SET_SELECTED_ORG_ACTIVITY) {
    return {
      ...state,
      selectedOrgActivity: action.data,
    };
  } else if (action.type === Actions.RESET_SELECTED_ACTIVITY) {
    return {
      ...state,
      selectedOrgActivity: null,
    };
  } else if (action.type === Actions.SET_ORGANIZATION_RENEWABLE_PLAN) {
    let selectedOrg = state.selectedOrg;
    return {
      ...state,
      selectedOrg: {
        ...selectedOrg,
        hasRenewablePlan: action.data,
      },
    };
  } else if (action.type === Actions.SET_ORG_DASHBOARD) {
    return {
      ...state,
      dashboardOrg: action.data,
    };
  } else if (action.type === Actions.SET_FETCH_CHILD_ORGS) {
    return {
      ...state,
      childOrgs: action.data,
    };
  } else if (action.type === Actions.SET_ORGNAME_ORGID) {
    return {
      ...state,
      planOrgName: action.data,
    };
  } else if (action.type === Actions.SET_FETCH_CHILD_ORG_DETAILS) {
    return {
      ...state,
      childOrgDetails: action.data,
    };
  } else if (action.type === Actions.SET_ORGANIZATION_OVERGUAGE_CHARGES) {
    let selectedOrg = state.selectedOrg;
    return {
      ...state,
      selectedOrg: {
        ...selectedOrg,
        planOverguageCharges: action.data,
      },
    };
  } else if (action.type === Actions.SET_CHILD_PLAN_DETAILS) {
    return {
      ...state,
      childPlanDetails: action.data,
    };
  } else if (action.type === Actions.PERSONAL_USER_ACTIVITIES) {
    return {
      ...state,
      userActivities: action.activities,
    };
  } else if (action.type === Actions.SET_TIMELINEGRAPH_DETAILS) {
    return {
      ...state,
      timelineDetails: action.data,
    };
  } else if (action.type === Actions.SET_SELECTED_ORG) {
    return {
      ...state,
      selectedOrg: action.data,
    };
  } else if (action.type === Actions.SET_ORGANIZATION_IMAGE) {
    let selectedOrg = state.selectedOrg;
    return {
      ...state,
      selectedOrg: {
        ...selectedOrg,
        orgImagePath: action.data,
      },
    };
  } else if (action.type === Actions.SET_ORG_DETAILS) {
    return {
      ...state,
      orgPath: action.data,
    };
  } else if (action.type === Actions.SET_ORG_ADDRESS) {
    return {
      ...state,
      orgAddress: action.data,
    };
  }

  return state;
}
